export const keepStaleInMinutes = (minutes: number) => ({
  staleTime: minutes * 60 * 1000,
  gcTime: minutes * 60 * 1000,
});

export const keepStaleInSeconds = (seconds: number) => ({
  staleTime: seconds * 1000,
  gcTime: seconds * 1000,
});
